__webpack_require__.p = "//cdn.myxrk.com//myxrk-v2/front-end/build/prod/ias/xrk/3.3.3/";